import { useFilterEmploymentTypeContext } from "./filter-employment-type.context";

export function FilterEmploymentType() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterEmploymentTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}